const URL_MY_QUOTE = 'my-quote';
const URL_PERSONAL_LINES = 'personal-lines';
const URL_CALLBACK = 'callback';

export { URL_CALLBACK, URL_MY_QUOTE, URL_PERSONAL_LINES };
